import { callAPI } from "features/yard360/store/helpers/apiCaller";
import { APIS } from "@/app/app-config";
import {
  FETCH_BUILDING_CODES,
  FETCH_BUILDING_CODES_SUCCESS,
  FETCH_BUILDING_CODES_FAILURE,
} from "features/yard360/store/buildingCodes/types";

export const fetchBuildingCodes = () => {
  return async (dispatch, getState) => {
    dispatch(fetchBuildingCodesRequest());

    try {
      const response = await callAPI(getState().authInfo, APIS.ListSupportedYardIdentifiers);

      dispatch(fetchBuildingCodesSuccess(response));
    } catch (e) {
      dispatch(fetchBuildingCodesFailure(e.message));
    }
  };
};

export const fetchBuildingCodesRequest = () => {
  return {
    type: FETCH_BUILDING_CODES,
  };
};

export const fetchBuildingCodesSuccess = (supportedYardIdentifiers) => {
  return {
    type: FETCH_BUILDING_CODES_SUCCESS,
    payload: supportedYardIdentifiers,
  };
};

export const fetchBuildingCodesFailure = (errorMessage) => {
  return {
    type: FETCH_BUILDING_CODES_FAILURE,
    payload: { errorMessage },
  };
};
